import type { PropsWithChildren } from "react"
import { useCallback, useState } from "react"
import { useLocation, ScrollRestoration } from "react-router"
import { ScrollRestorationContext } from "./ScrollRestorationContext"

export const ScrollRestorationProvider = ({ children }: PropsWithChildren) => {
	const [scrollPositions, setScrollPositions] = useState<Record<string, number>>({})
	const { pathname } = useLocation()

	const restore = useCallback(() => {
		const top = scrollPositions[pathname]
		if (top > 0) {
			window.scrollTo({ top })
		}
	}, [pathname, scrollPositions])

	const register = useCallback((newPathname: string) => {
		setScrollPositions((prevValue) =>
			prevValue[newPathname] === undefined ? { ...prevValue, [newPathname]: 0 } : prevValue,
		)
	}, [])

	const save = useCallback((savedPathname: string, scrollY: number) => {
		setScrollPositions((prevValue) => ({
			...prevValue,
			[savedPathname]: scrollY,
		}))
	}, [])

	return (
		<ScrollRestorationContext.Provider value={{ register, restore, save }}>
			{children}
			{/*
			 * No custom getKey here on purpose: react-router's default (location.key) is what we want,
			 * and passing a callback that changes identity on every navigation forces react-router to
			 * tear down and re-register its own scroll restoration wiring on every navigation, which can
			 * race with the actual scroll reset/restore and leave pages (e.g. VehicleDetails) scrolled
			 * to a stale position.
			 */}
			<ScrollRestoration />
		</ScrollRestorationContext.Provider>
	)
}
